import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_FLAT } from '@divvy-web/skylab.basicbutton'
import { RADIO_TILE_COLOR_NEUTRAL, RadioTile } from '@divvy-web/skylab.radiotilegroup'
import Spinner from '@divvy-web/skylab.spinner'
import Tag from '@divvy-web/skylab.tag'
import Tooltip, { TOOLTIP_POSITION_BOTTOM } from '@divvy-web/skylab.tooltip'

import styles from './styles.module.scss'
export interface BankAccountOptionProps {
  image?: React.ReactNode
  isSelected: boolean
  isStateChanging?: boolean
  name: string
  lastFour: string
  onDelete: () => void
  onSelected: () => void
}

const BankAccountOption = ({
  image,
  isSelected,
  isStateChanging,
  name,
  lastFour,
  onDelete,
  onSelected,
}: BankAccountOptionProps) => {
  const [getClassName, makeTestId] = useNameFormatter('BankAccountOption')

  return (
    <div
      className={`${styles[getClassName('')]} fs-mask`}
      data-testid={makeTestId(name)}
    >
      {isStateChanging && (
        <Spinner
          centeredWithAbsolutePositioning
          className={styles[getClassName('state-changing')]}
          dataTestId={makeTestId('state-changing')}
        />
      )}
      <RadioTile
        color={RADIO_TILE_COLOR_NEUTRAL}
        disabled={isStateChanging}
        isSelected={isSelected}
        label={
          <div className={styles[getClassName('label')]}>
            <div>{`${name} *${lastFour}`}</div>
            {isSelected && (
              <>
                <div className={styles[getClassName('label-divider')]} />
                <Tooltip
                  html={
                    <FormattedMessage
                      defaultMessage='Will be used for account payments'
                      id='sputnik.BankAccountOption__EqGN+2'
                    />
                  }
                  position={TOOLTIP_POSITION_BOTTOM}
                >
                  <Tag>
                    <FormattedMessage
                      defaultMessage='Primary'
                      id='sputnik.BankAccountOption__t2Wr8I'
                    />
                  </Tag>
                </Tooltip>
              </>
            )}
          </div>
        }
        tileImage={image}
        onInputChange={onSelected}
      />
      <BasicButton
        icon='close'
        type={BASIC_BUTTON_TYPE_FLAT}
        onClick={onDelete}
      />
    </div>
  )
}

export default BankAccountOption
